export const titleOptions = [
  { value: 'Miss', label: 'Miss' },
  { value: 'Mrs', label: 'Mrs' },
  { value: 'Mr', label: 'Mr' },
  { value: 'Ms', label: 'Ms' },
  { value: 'Mx', label: 'Mx' },
  { value: 'Dr', label: 'Dr' },
  { value: 'Prof.', label: 'Prof.' },
]
